import { atom } from 'recoil';

const returnedMessageCountAtom = atom({
    key: 'returnedMessageCount',
    default: 0
});

export {
    returnedMessageCountAtom
};